import React, { useEffect, useState } from "react";
import { Route, Switch, useHistory } from "react-router-dom";
import { Container, Menu, Sidebar, Button, Icon } from "semantic-ui-react";
import HomePage from "../Home/homePage";
import TakeSurvey from "../SurveyPlayer/takeSurvey";
import UserSurveyResults from "../SurveyPlayer/userSurveyResults";
import { useStore } from "../../stores/store";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";
import LanguageSwitcher from "../Common/languageSwitcher";
import SideBar from "../Home/SideBar";
import DownloadCertificate from "../Certificates/downloadCertificate";

export default observer(function OasisPublicPage() {
  const { i18n } = useTranslation("common");
  const { t } = useTranslation("common");
  const { commonStore } = useStore();
  const [menuOpened, setMenuOpened] = useState<boolean>(false);
  const history = useHistory();

  useEffect(() => {
    commonStore.setLanguage("en");
    commonStore.setCurrentSurveyId(0);
    if (!commonStore.lang || commonStore.lang == null) {
      commonStore.setLanguage(commonStore.defaultLang);
      i18n.changeLanguage(commonStore.defaultLang);
    } else {
      i18n.changeLanguage(commonStore.lang);
    }
  }, []);

  const openGlossary = () => {
    const uzb_en_glossary: string = "/assets/RefleCT_Glossary_ENG.pdf";
    const uzb_en_kh_glossary: string = "/assets/RefleCT_Glossary_ENG_KH.pdf";
    const uzb_uz_glossary: string = "/assets/RefleCT_Glossary_UZB.pdf";
    const uzb_ru_glossary: string = "/assets/RefleCT_Glossary_RUS.pdf";
    const uzb_kh_glossary: string = "/assets/RefleCT_Glossary_KH.pdf";
    const vn_glossary: string = "/assets/RefleCT_Glossary_VN.pdf";
    const id_glossary: string = "/assets/RefleCT_Glossary_ID.pdf";

    if (commonStore.lang === "ru" && uzb_ru_glossary && window)
      window.open(uzb_ru_glossary, "_blank")!.focus();
    else if (commonStore.lang === "uz" && uzb_uz_glossary && window)
      window.open(uzb_uz_glossary, "_blank")!.focus();
    else if (commonStore.lang === "kh" && uzb_kh_glossary && window)
      window.open(uzb_kh_glossary, "_blank")!.focus();
    else if (commonStore.lang === "vn" && vn_glossary && window)
      window.open(vn_glossary, "_blank")!.focus();
    else if (commonStore.lang === "id" && vn_glossary && window)
      window.open(id_glossary, "_blank")!.focus();
    else if (
      commonStore.lang === "en" &&
      commonStore.currentSurveyCode === "kh" &&
      uzb_kh_glossary &&
      window
    )
      window.open(uzb_en_kh_glossary, "_blank")!.focus();
    else window.open(uzb_en_glossary, "_blank")!.focus();
  };

  return (
    <>
      <div
        className={
          (commonStore && commonStore.lang === "kh" ? "App Oasis-App kh-content" : "App Oasis-App") +
          " " +
          (commonStore && commonStore.lang === "ru" ? "ru-content" : "") +
          " " +
          (commonStore && commonStore.lang === "vn" ? "vn-content" : "")
        }
      >
        <Menu widths={3}>
          <Menu.Item className="app-logo">
            <img alt="logo" src="/assets/ADB-logo.png" onClick={() => history.push("/")} />
          </Menu.Item>
          <Menu.Item className="reflect-logo">
            <img alt="logo" src="/assets/RefleCT.png" />
          </Menu.Item>
          <Menu.Item className="app-lang">
            {commonStore.currentSurveyId != 0 && <LanguageSwitcher />}
            <div className="gloss-btn">
              <Button
                icon
                labelPosition="left"
                onClick={() => {
                  openGlossary();
                }}
              >
                <Icon name="book" />
                {t("Common.Glossary")}
              </Button>
            </div>
            <div className="navbarmenu-btn-container">
              <Button
                className="navbarmenu-btn"
                icon
                floated="right"
                onClick={() => {
                  setMenuOpened(!menuOpened);
                }}
              >
                <Icon name="bars" />
              </Button>
            </div>
          </Menu.Item>
        </Menu>

        {/* <Dropdown icon="book" className="gloss-float">
          <Dropdown.Menu style={{ left: "-138px !important" }}>
            <Dropdown.Item>
              <a href="/assets/RefleCT_Glossary_ENG.pdf" target="_blank">
                <Flag name="uk" /> Glossary
              </a>
            </Dropdown.Item>
            <Dropdown.Item>
              <a href="/assets/RefleCT_Glossary_RUS.pdf" target="_blank">
                <Flag name="ru" /> глоссарий
              </a>
            </Dropdown.Item>
            <Dropdown.Item>
              <a href="/assets/RefleCT_Glossary_UZB.pdf" target="_blank">
                <Flag name="uz" /> lug'at
              </a>
            </Dropdown.Item>
          </Dropdown.Menu>
              </Dropdown> */}
        <Sidebar
          className="oasis-sidebar"
          as={Menu}
          animation="overlay"
          icon="labeled"
          direction="right"
          vertical
          visible={menuOpened}
          width="thin"
        >
          <SideBar onClose={() => setMenuOpened(false)} />
        </Sidebar>

        <Container className="lpoasis-survey-container">
          <div className="lpoasis-survey-content">
            <Switch>
              <Route exact path="/:surveyCode" component={TakeSurvey} />
              <Route exact path="/results/:surveyCode/:userSurveyCode" component={UserSurveyResults} />
              <Route
                exact
                path="/certificate/:surveyCode/:userSurveyCode/preview"
                component={DownloadCertificate}
              />
              {/*<Route exact path="/managequestions/:questionId/edit" component={AddEditQuestion} />
              <Route exact path="/manageQuestions" component={Managequestions} />*/}

              <Route path="/" component={HomePage} />
            </Switch>
          </div>
        </Container>
        <div className="lpoasis-footer">
          <Container>
            <p className="footer-powered">Powered by</p>
            <img className="footer-logo" alt="logo" src="/assets/LPOASIS.png" />
          </Container>
        </div>
      </div>
    </>
  );
});
